import {hasProp} from './props';
import {empty} from './strings';

const paramsRegex = /:([a-z_]+)/gi;

export function paramsReplacer(str, params) {
  try {
    return str.replace(paramsRegex, (m, p1) => {
      if (hasProp(params, p1)) {
        return params[p1];
      }

      throw Error();
    });
  } catch (e) {
    return empty;
  }
}
